import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import '../styles/planCard.css'
import { COLORS } from '../../../resources/colors-contants'
import RegularBtn from '../../buttons/RegularBtn'
import Modal from '../../modals/customModal'
import AppModal from '../../modals/modal'

interface productPlanCardProp {
    title?: string
    description?: string
    priceText?: any
    subPrice?: string
    arr?: { text: string }[]
    backgroundColor?: string
    perYear?: boolean
    duration?: string
    btnBackgroundColor?: string
    btnColor?: string
    btnText?: string
    cardBorderColor?: string
    discount?: any
    btnAction?: () => void
    isStyled?: boolean
    displayCheckIcon?: boolean
    displayPurchase?: boolean
    purchaseAction?: () => void
    disabled?: boolean
}
const ProductPlanCard: React.FC<productPlanCardProp> = ({
    title,
    description,
    priceText,
    subPrice,
    arr,
    backgroundColor,
    perYear,
    duration,
    discount,
    btnBackgroundColor,
    btnColor,
    btnText,
    cardBorderColor,
    isStyled,
    btnAction,
    displayPurchase,
    purchaseAction,
    disabled,
}) => {
    const cardContent = {
        border: cardBorderColor,
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '40px',
        paddingBottom: '40px',
        borderRadius: '10px',
        backgroundColor: backgroundColor
    }
     const [show, setShow] = useState(false);
      const [token] = useState<string | null>(localStorage.getItem('token'));
      console.log({token});
      
    
    return (
        <div className="">
            <div style={isStyled ? {} : cardContent} className="d-lg-block d-none">
                <h4 id="planCardHead" style={{ fontWeight: '600', marginBottom: '2rem', color: COLORS.product_headings }}>
                    {title}
                </h4>
                <p id="planCardDesc" style={{ fontWeight: '400', letterSpacing: '-2%', color: COLORS.product_paragraph }}>
                    {description}
                </p>
                <div className="mt-5 mb-4 mb-md-5">
                    {perYear ? (
                        <>
                            <div>
                                {discount && (
                                    <s id="discountText" style={{ color: '#888C91', fontWeight: '600' }}>
                                        {discount}
                                    </s>
                                )}
                            </div>
                            <div>
                                <span id="priceText" style={{ fontWeight: '600', letterSpacing: '-2%' }}>
                                    {priceText}
                                </span>
                                <span id="perYear" style={{ color: '#394049', fontWeight: '400' }}>
                                    /{duration}
                                </span>
                            </div>
                        </>
                    ) : (
                        <span id="priceText" style={{ fontWeight: '600', letterSpacing: '-2%' }}>
                            {priceText}
                        </span>
                    )}
                </div>
                {/* <p id="featureHead" style={{ fontWeight: '500' }}>
                    Features Include:
                </p> */}
                {/* {title === 'Plus' ? <><p style={{fontWeight: 500, color: btnBackgroundColor}}>Free on 1st year for one branch only</p></> : ''} */}
                {arr &&
                    arr.map((dat, index) => (
                        <div className="d-flex mb-2" key={index}>
                            {title === 'Enterprise' ? (
                                ''
                            ) : (
                                <>
                                    <img src="/assets/check1.svg" alt="" className="me-3" style={{ marginTop: '-10px' }} />
                                </>
                            )}
                            {/* <FontAwesomeIcon className="me-3 mt-1" icon={faCheck} /> */}
                            <p id="featureHead" style={{ fontWeight: '400' }}>
                                {dat.text}
                            </p>
                        </div>
                    ))}

                {isStyled ? <div style={{ marginTop: '4rem' }}></div> : ''}

                {isStyled ? (
                    <div>
                        <button
                            className="signup__col--btn mx-4"
                            style={{
                                backgroundColor: btnBackgroundColor,
                                color: btnColor,
                                width: '90%',
                                position: 'absolute',
                                bottom: '50px',

                                left: '0%'
                            }}
                           onClick={() => {
                                if (btnText !== 'Contact sales' && token!== null) {
                                    if (token != null) {
                                        alert("You are on 7 days trial/Subscription");
                                        return;
                                    }
                                    // setShow(true)
                                } else if (btnAction) {
                                    btnAction();
                                }
                            }}
                            // disabled={btnText !== "Contact sales" ? disabled : false}
                        >
                            {btnText}
                        </button>
                    </div>
                ) : (
                    // <div className="text-center" style={{ position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)' }}>

                    //     {/* <RegularBtn
                    //         btnAction={btnAction}
                    //         text={btnText}
                    //         className='signup__col--btn'
                    //         backgroundColor={btnBackgroundColor}
                    //         color={btnColor}
                    //         regPad="py-2"

                    //         // padding="10px"rem
                    //         // borderRadius="10px"
                    //     /> */}
                    // </div>
                    <div className="text-center mt-4 ">
                        <RegularBtn
                            btnAction={btnAction}
                            text={btnText}
                            width="350px"
                            backgroundColor={'yellow'}
                            color={btnColor}
                            regPad="py-2"
                            btnHeight="48px"
                            disabled={disabled}
                            // padding="10px"rem
                            // borderRadius="10px"
                        />
                    </div>
                )}
                <div
                    className=""
                    style={{
                        top: '50%',
                        transform: 'translate(35%, 100%)',
                        position: 'relative'
                    }}
                >
                    {(btnText?.toLocaleLowerCase().includes('try free for 7 days') || btnText?.toLocaleLowerCase().includes('on trial'))? (
                        <button className="bg-transparent border-0 cursor-pointer navigation__menu--active" style={{ fontSize: 14 }} onClick={purchaseAction}>
                            Purchase now{' '}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 9H15M15 9L10 4M15 9L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    ) : (
                        ''
                    )}
                </div>
            </div>

            <div style={isStyled ? {} : cardContent} className="d-md-block d-lg-none ">
                <h4 id="planCardHead" style={{ fontWeight: '600', marginBottom: '2rem', color: COLORS.product_headings }}>
                    {title}
                </h4>
                <p id="planCardDesc" style={{ fontWeight: '400', letterSpacing: '-2%', color: COLORS.product_paragraph }}>
                    {description}
                </p>
                <div className="mt-5 mb-4 mb-md-5">
                    {perYear ? (
                        <>
                            <div>
                                {discount && (
                                    <s id="discountText" style={{ color: '#394049', fontWeight: '600' }}>
                                        {discount}
                                    </s>
                                )}
                            </div>
                            <div>
                                <span id="priceText" style={{ fontWeight: '600', letterSpacing: '-2%' }}>
                                    {priceText}
                                </span>
                                <span id="perYear" style={{ color: '#394049', fontWeight: '400' }}>
                                    /{duration}
                                </span>
                            </div>
                        </>
                    ) : (
                        <span id="priceText" style={{ fontWeight: '600', letterSpacing: '-2%' }}>
                            {priceText}
                        </span>
                    )}
                </div>

                {/* {title === 'Plus' ? <><p style={{fontWeight: 500, color: btnColor}}>Free on 1st year for one branch only</p></> : ''} */}
                {arr &&
                    arr.map((dat, index) => (
                        <div className="d-flex mb-2" key={index}>
                            {title === 'Enterprise' ? (
                                ''
                            ) : (
                                <>
                                    <img src="/assets/check1.svg" alt="" className="me-3" style={{ marginTop: '-10px' }} />
                                </>
                            )}
                            {/* <FontAwesomeIcon className="me-3 mt-1" icon={faCheck} /> */}
                            <p id="featureHead" style={{ fontWeight: '400' }}>
                                {dat.text}
                            </p>
                        </div>
                    ))}

                {isStyled ? <div style={{ marginTop: '4rem' }}></div> : ''}

                {isStyled ? (
                    <div>
                        <button
                        // disabled={btnText !== 'Contact sales' ? disabled : false}
                            className="signup__col--btn"
                            style={{
                                backgroundColor: btnBackgroundColor,
                                color: btnColor
                            }}
                           onClick={() => {
                                if (btnText !== 'Contact sales' && token!== null) {
                                    //   setShow(true)
                                    alert("You are on 7 days trial/Subscription");
                                } else if (btnAction) {
                                    btnAction();
                                }
                            }}
                        >
                            {btnText}
                        </button>
                    </div>
                ) : (
                    // <div className="text-center" style={{ position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)' }}>
                    //     <RegularBtn
                    //         btnAction={btnAction}
                    //         text={btnText}
                    //         width="300px"
                    //         backgroundColor={btnBackgroundColor}
                    //         color={btnColor}
                    //         regPad="py-2"

                    //         // padding="10px"rem
                    //         // borderRadius="10px"
                    //     />
                    // </div>
                    <div className="text-center mt-4">
                        <RegularBtn
                            btnAction={btnAction}
                            text={btnText}
                            width="250px"
                            backgroundColor={btnBackgroundColor}
                            color={btnColor}
                            regPad="py-2"
                            btnHeight="48px"
                             disabled={disabled}
                            // padding="10px"rem
                            // borderRadius="10px"
                        />
                    </div>
                )}
                  <div
                    className=""
                    style={{
                        top: '50%',
                        transform: 'translate(35%, 100%)',
                        position: 'relative'
                    }}
                >
                    {(btnText?.toLocaleLowerCase().includes('try free for 7 days') || btnText?.toLocaleLowerCase().includes('on trial')) ? (
                        <button className="bg-transparent border-0 cursor-pointer navigation__menu--active" style={{ fontSize: 14 }} onClick={purchaseAction}>
                            Purchase now{' '}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 9H15M15 9L10 4M15 9L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            <AppModal show={show} onClose={() => setShow(false)} title="Change phone number">
        <div className="modal-body">
          Dear user you are on trial/subscription!
        </div>
        
      </AppModal>
            {/* <Modal
                title='On trial Details'
                id='ontrial'
                show={false}
                onClose={() => !sh}
            >
                <p>You are on 7 days trial/Subscription</p>
            </Modal> */}
        </div>
    )
}

export default ProductPlanCard
